/* Keeps the offer box percentage and the savings chip suffix in sync when the shopper changes variant. tm-product.js rewrites the price row on every variant change; this watches for that. */
(function () {
  function init(root) {
    var sid = root.getAttribute('data-tm-product-section');
    var price = document.getElementById('tm-price-' + sid);
    var input = document.getElementById('tm-variant-id-' + sid);
    var dataEl = document.getElementById('tm-product-data-' + sid);
    if (!price || !input || !dataEl) return;
    var product;
    try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var offer = document.getElementById('tm-offer-' + sid);
    var suffix = price.getAttribute('data-save-suffix') || '';
    function sync() {
      var id = String(input.value), v = null;
      for (var i = 0; i < product.variants.length; i++) {
        if (String(product.variants[i].id) === id) { v = product.variants[i]; break; }
      }
      var pct = 0;
      if (v && v.compare_at_price && v.compare_at_price > v.price) {
        pct = Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price);
      }
      if (offer) {
        offer.hidden = pct <= 0;
        var el = offer.querySelector('[data-tm-offer-pct]');
        if (el && pct > 0) el.textContent = pct + '%';
      }
      if (suffix) {
        var chip = price.querySelector('.tm-product__save');
        if (chip && chip.getAttribute('data-suffixed') !== '1') {
          chip.textContent = chip.textContent + ' ' + suffix;
          chip.setAttribute('data-suffixed', '1');
        }
      }
    }
    sync();
    new MutationObserver(sync).observe(price, { childList: true });
  }
  function boot() { document.querySelectorAll('[data-tm-product-section]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
